import { fetchQuery, graphql, GraphQLTaggedNode, OperationType } from "relay-runtime"
import { useChMedicationSearchItemQueryProductQuery } from "@/modules/patients/detail/medication/services/__generated__/useChMedicationSearchItemQueryProductQuery.graphql"
import { useChMedicationSearchItemQueryTemplateQuery } from "@/modules/patients/detail/medication/services/__generated__/useChMedicationSearchItemQueryTemplateQuery.graphql"
import { useChMedicationSearchQuery } from "@/modules/patients/detail/medication/services/__generated__/useChMedicationSearchQuery.graphql"
import { chMedicationSearchQuery } from "@/modules/patients/detail/medication/services/useChMedicationSearchQuery"
import { RelayEnvironment } from "@/relay-environment"
import { Language } from "@/types/__generated__/union-types"

const chMedicationProductSearchItemQuery = graphql`
  query useChMedicationSearchItemQueryProductQuery($pharmacode: Int!) {
    ch_medicationProductSearchItem(pharmacode: $pharmacode) {
      hasNews
      articles {
        description
        globalTradeItemNumber
        pharmacode
        publicPrice
      }
      category
      description
      eveningDosage
      medicationType
      morningDosage
      nightDosage
      therapyDurationDays
      noonDosage
      productUrl
      unit
      usageInstructions
      atcCode
      isGeneric
    }
  }
`
const chMedicationTemplateSearchItemQuery = graphql`
  query useChMedicationSearchItemQueryTemplateQuery($patientLanguage: Language!, $templateId: Int!) {
    ch_medicationTemplateSearchItem(patientLanguage: $patientLanguage, templateId: $templateId) {
      hasNews
      articles {
        description
        globalTradeItemNumber
        pharmacode
        publicPrice
      }
      category
      description
      eveningDosage
      medicationType
      morningDosage
      nightDosage
      therapyDurationDays
      noonDosage
      productUrl
      unit
      usageInstructions
      atcCode
      isGeneric
    }
  }
`

async function handleFetch<T extends OperationType>(
  query: GraphQLTaggedNode,
  params: Record<string, unknown>,
  signal: AbortSignal,
) {
  return fetchQuery<T>(RelayEnvironment, query, params, {
    fetchPolicy: "store-or-network",
    networkCacheConfig: { metadata: { signal } },
  }).toPromise()
}

export async function handleMedicationSearch(
  params: { searchTerm: string; includeTemplates: boolean; patientId: string; appointmentId?: string | null },
  signal: AbortSignal,
) {
  const response = await handleFetch<useChMedicationSearchQuery>(chMedicationSearchQuery, params, signal)

  return response?.ch_medicationSearch
}

export async function handleMedicationSearchItem(
  signal: AbortSignal,
  type: "PREPARATION" | "TEMPLATE",
  language: Language,
  templateId?: number | null,
  pharmacode?: number | null,
) {
  if (type === "TEMPLATE" && templateId) {
    const response = await handleFetch<useChMedicationSearchItemQueryTemplateQuery>(
      chMedicationTemplateSearchItemQuery,
      { templateId, patientLanguage: language },
      signal,
    )

    return response?.ch_medicationTemplateSearchItem
  }

  if (pharmacode) {
    const response = await handleFetch<useChMedicationSearchItemQueryProductQuery>(
      chMedicationProductSearchItemQuery,
      { pharmacode },
      signal,
    )

    return response?.ch_medicationProductSearchItem
  }

  return null
}
